/**
 * Textos da ficha da leitura (E139.F3, GUS-142, ADR-0095): cada informação do caso com o valor que o
 * exame usa, como está impressa e onde, e a situação de cada página recebida. A ficha diz o que a
 * leitura achou e o que não achou; a ausência no documento só o perito afirma.
 */
export const ptBRFicha = {
  titulo: 'Informações e limites da leitura',
  ressalva: 'Informação extraída não é prova automática de autoria.',
  versao: 'Leitura registrada em {quando} (versão {versao}).',
  carregando: 'Carregando a leitura dos documentos…',
  vazio: 'A leitura dos documentos aparece aqui depois do exame do caso.',
  erro: 'Não foi possível carregar a leitura dos documentos. Tente novamente.',
  semPermissao: 'A leitura dos documentos é da equipe que atende o caso.',
  tentarDeNovo: 'Tentar de novo',
  emLeitura:
    'Há páginas em imagem sendo lidas. A lista se atualiza sozinha quando a leitura terminar.',
  colunas: {
    informacao: 'Informação',
    valor: 'Valor e situação',
    fonte: 'Fonte e detalhe',
  },
  // E162.F2.T03 (GUS-142): o valor e o selo à vista; a fonte, a página e o porquê por expansão.
  verDetalhe: 'Ver fonte e detalhe',
  seloDivergencia: 'Diverge entre fontes',
  grupo: {
    contrato: 'Contrato',
    pessoas_e_papeis: 'Pessoas e papéis',
    atos_e_registros: 'Atos e registros',
  },
  campo: {
    numero_da_cedula: 'Número da cédula',
    data_de_emissao: 'Data de emissão',
    nascimento: 'Data de nascimento',
    documento_de_identidade: 'Documento de identidade',
    endereco: 'Endereço',
    finalidade: 'Finalidade da operação',
    valor_liberado: 'Valor liberado',
    saldo_devedor_pago: 'Saldo devedor pago',
    forma_de_liberacao: 'Forma de liberação',
    banco_da_liberacao: 'Banco da liberação',
    agencia_da_liberacao: 'Agência da liberação',
    conta_da_liberacao: 'Conta da liberação',
    signatario_nome: 'Nome do signatário',
    signatario_cpf: 'CPF do signatário',
    signatario_email: 'E-mail do signatário',
    identificacao_na_plataforma: 'Identificação na plataforma',
    correspondente: 'Correspondente',
    instante_da_assinatura: 'Instante da assinatura',
    ip_do_signatario: 'Endereço IP do signatário',
    sessao_da_biometria: 'Sessão da biometria',
    codigo_declarado: 'Código declarado',
  },
  codigoDaPeca: 'Código declarado de {peca}',
  situacao: {
    lido: 'Lido',
    em_branco: 'Em branco no documento',
    nao_localizado: 'Não localizado pela leitura',
    ilegivel: 'Ilegível',
    nao_processado: 'Não processado',
    deduzido: 'Deduzido, não impresso',
  },
  motivo: {
    rotulo_e_valor_no_papel: 'O rótulo e o valor estão impressos na fonte.',
    valor_no_papel: 'O valor está impresso na fonte, sem o rótulo ao lado.',
    valor_no_papel_ate_o_minuto:
      'O instante está impresso na fonte só até o minuto; os segundos do exame não são conferíveis no papel.',
    valor_sem_trecho: 'O exame tem o valor, e a leitura não achou o trecho impresso.',
    no_papel_sem_uso: 'Impresso no documento e ausente do exame: confira.',
    rotulo_sem_valor: 'O rótulo está impresso e o campo está vazio.',
    sem_documento_esperado: 'O caso não tem o documento em que esta informação é impressa.',
    nem_rotulo_nem_valor:
      'Os documentos esperados foram lidos e a informação não apareceu. Isso não afirma que ela falte no papel.',
    leitura_com_falha: 'A leitura de um documento esperado, ou de uma página dele, falhou.',
    documento_sem_leitura: 'Um documento esperado ainda não foi lido.',
    pagina_sem_leitura: 'Uma página em imagem de um documento esperado ainda está sendo lida.',
    operacao_nova:
      'Operação nova: o saldo pago é zero pela natureza da operação, não por estar impresso.',
    marca_do_layout: 'A forma vem do formulário do documento, não de texto impresso.',
    associacao_ambigua:
      'Há um número impresso na linha que pode ser deste campo ou de outro do mesmo quadro. Confira na fonte.',
  },
  impresso: 'Impresso: {literal}',
  emBranco: 'em branco',
  noCadastro: 'No cadastro: {valor}',
  divergencia: 'Diverge: {valor} em {fonte}',
  semValor: 'Sem valor no exame',
  fonte: '{documento}, página {pagina}',
  fonteSemPagina: '{documento}',
  origemImagem: 'lido da imagem',
  verNaFonte: 'Ver na fonte',
  verPagina: 'Ver a página {pagina} de {documento}',
  semFonte: 'Sem trecho localizado',
  documentos: {
    titulo: 'Documentos do caso',
    subtitulo: 'Cada página recebida, o documento em que ela caiu e a situação da leitura.',
    paginas: '{n} página(s)',
    pagina: 'Página {n}',
    noDocumento: '{documento}, página {pagina}',
    foraDeDocumento: 'Fora de qualquer documento',
    semPaginas: 'Ainda não há páginas registradas.',
  },
  situacaoDaPagina: {
    lida: 'Lida',
    nada_lido: 'Imagem sem texto legível',
    por_ler: 'Imagem em leitura',
    leitura_com_falha: 'Leitura com falha',
    em_branco: 'Em branco',
    imagem: 'Imagem',
    nao_processada: 'Não processada',
    sem_documento: 'Fora de documento',
  },
  textoDaPagina: {
    camada: 'texto do arquivo',
    imagem: 'lido da imagem',
    nenhum: 'sem texto lido',
  },
  // E184.F4.T01 (GUS-145 item 3): o original numa aba nova, para copiar o texto do PDF.
  original: {
    abrir: 'Abrir o original',
    abrindo: 'Abrindo…',
    abrirO: 'Abrir o original de {documento} numa aba nova',
    dica: 'Abre numa aba nova. No PDF com texto, dá para selecionar e copiar; foto e digitalização abrem como imagem.',
    erro: 'Não foi possível abrir o original. Tente de novo.',
    divergente: 'O arquivo guardado não confere com o recebido. O original não é aberto.',
  },
  pagina: {
    carregando: 'Carregando a página…',
    erro: 'Não foi possível abrir a página.',
    divergente: 'O arquivo guardado não confere com o recebido. A página não é exibida.',
    alt: 'Página {pagina} de {documento}',
  },
  // E155.F3 (GUS-192, ADR-0105 §2.7): rever a leitura de um campo ou de um documento na fonte.
  releitura: {
    abrir: 'Rever leitura de um campo',
    abrirDocumento: 'Rever documento na fonte',
    titulo: 'Rever leitura na fonte',
    subtitulo:
      'Corrija somente o ponto necessário, preservando os documentos e as versões anteriores.',
    secaoCampo: 'Campo a conferir',
    campo: 'Campo',
    leituraAtual: 'Leitura atual',
    leituraProposta: 'Leitura proposta',
    fonte: 'Fonte',
    semLeituraAtual: 'Sem valor em uso no exame',
    semFonte: 'Sem trecho localizado',
    detalhes: 'Ver fonte e detalhes técnicos',
    localizador: 'Localizador: {fonte}',
    semLocalizador: 'Localizador: nenhum trecho localizado na leitura atual.',
    versaoDaFicha: 'Leitura registrada na versão {versao} da ficha.',
    ressalvaProposta: 'A leitura proposta não é confirmação pericial.',
    motivoRotulo: 'O que precisa ser revisto?',
    motivoAjuda: 'Mínimo de {n} caracteres. O motivo fica no registro da revisão, com a autoria.',
    solicitar: 'Solicitar nova leitura deste ponto',
    confirmarComFonte: 'Confirmar com fonte',
    voltar: 'Voltar à análise',
    enviando: 'Enviando…',
    valorRotulo: 'Valor como está impresso',
    documentoRotulo: 'Documento da fonte',
    paginaRotulo: 'Página',
    paginaAjuda: 'Deixe em branco quando o documento não tem página numerada.',
    confirmar: 'Confirmar leitura com fonte',
    autoria:
      'Ao confirmar, você assume a autoria do valor e da fonte apontada. O registro diz se o texto lido da página confirma o valor.',
    resultado: {
      mudou: 'A leitura mudou. O valor entrou no exame e as peças foram verificadas de novo.',
      sem_mudanca: 'Sem mudança: a fonte confirma o valor em uso no exame.',
      ambigua: 'A leitura achou mais de um valor impresso. Escolha o certo e confirme com a fonte.',
      nao_localizado:
        'A leitura não achou o campo pelo rótulo. Informe o valor como está impresso e a fonte.',
    },
    feita: 'Nova leitura solicitada.',
    feitaTexto:
      'O ponto e os dependentes pertinentes voltam à conferência. A entrega anterior foi preservada.',
    reverificadas: '{n} peça(s) verificada(s) de novo.',
    pecasReabertas: '{n} peça(s) concluída(s) reaberta(s).',
    localizado: 'O texto lido da página confirma o valor.',
    naoLocalizado:
      'O texto lido da página não mostra o valor: a fonte vale pela autoria de quem confirmou.',
    candidatas: 'Valores impressos encontrados',
    usarCandidata: 'Usar este valor',
    rodape:
      'A revisão do campo precisa de fonte e autoria. Um pedido do cliente não substitui aprovação técnica.',
    recusa: {
      sem_ficha: 'O caso ainda não tem leitura registrada para rever.',
      fonte_nao_encontrada: 'O documento ou a página apontada não é do caso.',
      peca_nao_encontrada: 'A peça deste código não está mais no caso.',
      caso_nao_encontrado: 'O caso não está ao alcance desta sessão.',
      sem_protocolo:
        'O caso não tem protocolo informado. Informe o protocolo antes de rever a leitura.',
      esgotada: 'O limite de {n} releituras deste campo acabou. Resta a confirmação com fonte.',
      certificada:
        'Uma peça concluída já teve a certificação requerida. A mudança pede a reemissão, não a releitura.',
      campo_sem_releitura:
        'Este campo não se revê por aqui: o instante da assinatura é conferido com os eventos e horários.',
      sem_forma:
        'O valor não tem a forma que o exame aceita para este campo. Confira como está impresso.',
      documento_sem_campos: 'Nenhuma informação da ficha é esperada neste documento.',
      fora_do_exame_eletronico: 'Este caso não é de exame eletrônico.',
      peca_concluida:
        'Uma peça concluída impediu a verificação. Atualize a página e tente de novo.',
      verificacao_indisponivel: 'A verificação não pôde ser refeita agora. Atualize a página.',
      pedido_invalido:
        'Escreva o motivo com pelo menos {n} caracteres e confira o valor, o documento e a página.',
      sem_permissao: 'A revisão da leitura é da equipe que atende o caso.',
      indisponivel: 'Não foi possível registrar agora. Tente novamente.',
    },
    documento: {
      intro:
        'Para reler de uma vez todas as informações que o catálogo espera num documento do caso.',
      titulo: 'Rever todos os campos de {documento}',
      texto:
        'As informações que o catálogo espera neste documento são lidas de novo pelo rótulo. O que mudou entra no exame de uma vez; o ambíguo e o não localizado voltam listados para a confirmação com fonte.',
      solicitar: 'Reler as informações deste documento',
      feita: 'Releitura do documento registrada.',
      resumo: {
        aplicados: 'Aplicados',
        sem_mudanca: 'Sem mudança',
        ambiguos: 'Ambíguos',
        nao_localizados: 'Não localizados',
        esgotados: 'Sem releitura disponível',
        sem_forma: 'Sem a forma que o exame aceita',
      },
      nenhum: 'nenhum',
    },
  },
} as const;
